import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllCompanys = async (filters, page, size) => {
  try {
    const response = await api.get(`/company`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createCompany = async (companyData) => {
  try {
    const response = await api.post('/company', companyData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao criar empresa.');
  }
};

export const getCompanyData = async (companyId) => {
  try {
    const response = await api.get(`/company/${companyId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados da empresa.');
  }
};

export const updateCompany = async (companyId, data) => {
  try {
    const response = await api.put(`/company/${companyId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar a empresa.');
  }
};